import * as React from 'react'
import { Helmet } from 'react-helmet'

type Props = {
	title: string
}

export const PageTitle: React.FC<Props> = ({ title }) => {
	return (
		<Helmet
			onChangeClientState={(newState) => {
				window.dispatchEvent(
					new CustomEvent('mondossier:title-ready', {
						detail: { title: newState.title }
					})
				)
			}}
		>
			<title>{title}</title>
		</Helmet>
	)
}
